import { wrapWithProvider } from "./src/browser_helpers";

export const wrapRootElement = wrapWithProvider;
